import { LadybugIcon } from './LadybugIcon';

/**
 * author: Google
 * id 97AFF594-E421-4757-BE72-1D6C428E27AE
 * name ladybug
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ladybug.svg
 * tags
 * - Nature 
 */
export const LadybirdIcon = LadybugIcon;
export default LadybirdIcon